import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose, withState } from 'recompose'

import { Button } from 'components/base'

import { Delete, Leave } from 'components/Channels/Controls'
import { providesChannelMutations } from 'components/Channels/dataSync'

import {
  record as ChannelsRecord,
  selectors as ChannelsSelectors,
} from 'data/channels'
import { isPrivate } from 'data/channels/record'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'

class LeaveAndExit extends Component {
  static propTypes = {
    channel: PropTypes.instanceOf(ChannelsRecord),
    updateChannel: PropTypes.func.isRequired,
    deleteChannel: PropTypes.func.isRequired,
    leaveChannel: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  static defaultProps = {
    onClose: () => {},
  }

  render() {
    const { channel, onClose, numberOfAdmins, canManage } = this.props

    return (
      <div>
        <div className="flexbox margin-top-larger">
          {isPrivate(channel) && (
            <div>
              {numberOfAdmins === 1 && channel.currentUserRole === 'admin' ? (
                <TooltipOnHover
                  id={
                    `can't-leave-channel` // Only one admin in channel and it is the current user
                  }
                  placement="right"
                  tooltipContent="Set someone else as admin to leave this channel"
                >
                  <div className="margin-right-normal margin-bottom-normal">
                    <Button.Secondary
                      className="margin-vertical-normal"
                      style={{ pointerEvents: 'none' }}
                    >
                      Leave this channel
                    </Button.Secondary>
                  </div>
                </TooltipOnHover>
              ) : (
                <div className="margin-right-normal margin-bottom-normal">
                  <Leave channel={channel} onLeave={onClose}>
                    <Button.Secondary className="margin-vertical-normal">
                      Leave this channel
                    </Button.Secondary>
                  </Leave>
                </div>
              )}
            </div>
          )}

          {canManage && (
            <div style={{ width: '50%' }}>
              <Delete channel={channel} onDelete={onClose}>
                <Button.Danger className="margin-vertical-normal">
                  Delete this channel
                </Button.Danger>
              </Delete>
            </div>
          )}
        </div>
      </div>
    )
  }
}

function makeMapStateToProps() {
  const channelAdminCountSelector = ChannelsSelectors.createChannelAdminCountSelector()

  return (state, { channelId }) => {
    const channel = ChannelsSelectors.getChannel(state, channelId)
    const numberOfAdmins = channelAdminCountSelector(state, channelId)
    return {
      channel,
      numberOfAdmins,
    }
  }
}

export default compose(
  providesChannelMutations,
  connect(makeMapStateToProps),
  withState('channelName', 'setChannelName', ({ channel }) => channel.name)
)(LeaveAndExit)
